import { createContext, ReactNode, useContext, useState } from "react";

type FolderListContextValue = {
  ownerUserIdFilter: string;
  followedByUserIdFilter: string;
  setOwnerUserIdFilter: (value: string) => void;
  setFollowedByUserIdFilter: (value: string) => void;
  myFoldersFilter: boolean;
  setMyFoldersFilter: (value: boolean) => void;
};

const FolderListContext = createContext<FolderListContextValue | undefined>(undefined);

export const useFolderListContext = () => {
  const context = useContext(FolderListContext);
  if (!context) {
    throw new Error("useFolderListContext must be used within a FolderListProvider");
  }
  return context;
};

type FolderListProviderProps = {
  children: ReactNode;
};

export const FolderListProvider = ({ children }: FolderListProviderProps) => {
  const [ownerUserIdFilter, setOwnerUserIdFilter] = useState<string>("");
  const [followedByUserIdFilter, setFollowedByUserIdFilter] = useState<string>("");
  const [myFoldersFilter, setMyFoldersFilter] = useState<boolean>(false);
  const value: FolderListContextValue = {
    ownerUserIdFilter,
    followedByUserIdFilter,
    setOwnerUserIdFilter,
    setFollowedByUserIdFilter,
    myFoldersFilter,
    setMyFoldersFilter,
  };

  return <FolderListContext.Provider value={value}>{children}</FolderListContext.Provider>;
};
